import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { NotFoundPage } from './not-found.page';
import { RouterModule } from '@angular/router';
import { SquadCastComponentsModule } from '../../components/squadcast.components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild([
      {
        path: '',
        component: NotFoundPage,
      },
    ]),
    SquadCastComponentsModule,
  ],
  declarations: [NotFoundPage],
})
export class NotFoundPageModule {}
